@use '@lib/assets/styles/main' as *;

.wrapper {
  position: relative;
  min-height: 165px;
  padding: 16px;
}

.siteNameWrap {
  margin-bottom: 16px;
}

.siteNameLink,
.siteName {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.address {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.error {
  text-align: center;
  color: $gray500;
  padding: 16px;
}
